export default "/dist/acura/static/media/2EDEC5_0_0.woff";